import React from 'react'
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Transition,
} from '@headlessui/react'
import { ApolloConsumer, useQuery } from '@apollo/client';
import { HiXMark, HiBars3 } from "react-icons/hi2";
import { FaRegBell } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useScrollToTop from '../components/useScrollToTop.js';
import { CgProfile } from "react-icons/cg";



const navigation = [
    { name: 'Dashboard', href: '/adminhome', current: true },
    { name: 'Carousel', href: '/carousel', current: false },
    { name: 'Advertisement', href: '/adminad', current: false },
    { name: 'Payment', href: '/adminpayment', current: false },
    { name: 'Edit', href: '/adminedit', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const signOut = (client) => {
    localStorage.clear()
    sessionStorage.clear();
    client.resetStore();
    toast.success("user logged out successfully!", {
        autoClose: 2000
    })
};
const AdminHeader = () => {
    useScrollToTop();

    return (
        <>
            <Disclosure as="nav" className="border border-b-slate-200 text-sm">
                {({ open }) => (
                    <>
                        <div className="mx-auto max-w-auto px-2 sm:px-6 lg:px-8">
                            <div className="relative flex h-16 items-center justify-between">
                                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                    <DisclosureButton className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-slate-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Open main menu</span>
                                        {open ? (
                                            <HiXMark className="block h-6 w-6" aria-hidden="true" />
                                        ) : (
                                            <HiBars3 className="block h-6 w-6" aria-hidden="true" />
                                        )}
                                    </DisclosureButton>
                                </div>
                                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                                    <div className="flex flex-shrink-0 items-center">
                                        <Link to='/adminhome'>
                                            <img
                                                className="h-9 w-auto"
                                                // src="/heart-svgrepo-com (1) 27-Photoroom.png"
                                                alt="Your Company"
                                            />
                                        </Link>
                                    </div>
                                    <div className="hidden sm:ml-6 sm:block">
                                        <div className="flex space-x-4">
                                            {navigation.map((item) => (
                                                <Link
                                                    key={item.name}
                                                    to={item.href}
                                                    className={classNames(
                                                        item.current ? 'bg-slate-900 text-white' : 'text-black hover:ring-1 hover:ring-gray-300 hover:text-black',
                                                        'rounded-md px-3 py-2 text-sm font-medium',
                                                    )}
                                                    aria-current={item.current ? 'page' : undefined}
                                                >
                                                    {item.name}
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                                    <button
                                        type="button"
                                        className="relative rounded-full p-1 text-black focus:outline-none"
                                    >
                                        <span className="absolute -inset-1.5" />
                                        <span className="sr-only">View notifications</span>
                                        <FaRegBell className="h-6 w-6" aria-hidden="true" />
                                    </button>

                                    <Menu as="div" className="relative ml-3">
                                        <div>
                                            <MenuButton className="relative flex rounded-full text-sm focus:outline-none">
                                                <span className="absolute -inset-1.5" />
                                                <span className="sr-only">Open user menu</span>
                                                <CgProfile className='h-7 w-7' />
                                            </MenuButton>
                                        </div>
                                        <Transition
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                <MenuItem>
                                                    {({ focus }) => (
                                                        <a
                                                            href="#"
                                                            className={classNames(focus ? 'bg-slate-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                                        >
                                                            Your Profile
                                                        </a>
                                                    )}
                                                </MenuItem>
                                                <MenuItem>
                                                    {({ focus }) => (
                                                        <a
                                                            href="#"
                                                            className={classNames(focus ? 'bg-slate-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                                        >
                                                            Settings
                                                        </a>
                                                    )}
                                                </MenuItem>
                                                <MenuItem>
                                                    {({ focus }) => (
                                                        <ApolloConsumer>
                                                            {client => (
                                                                <Link
                                                                    to="/signup" onClick={() => signOut(client)}
                                                                    className={classNames(focus ? 'bg-slate-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                                                >
                                                                    Sign out
                                                                </Link>
                                                            )}
                                                        </ApolloConsumer>
                                                    )}
                                                </MenuItem>
                                            </MenuItems>
                                        </Transition>
                                    </Menu>
                                </div>
                            </div>
                        </div>

                        <DisclosurePanel className="sm:hidden">
                            <div className="space-y-1 px-2 pb-3 pt-2">
                                {navigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        as="a"
                                        to={item.href}
                                        className={classNames(
                                            item.current ? 'bg-slate-900 text-white' : 'text-black hover:ring-1 hover:ring-gray-300 hover:text-black',
                                            'block rounded-md px-3 py-2 text-base font-medium',
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </div>
                        </DisclosurePanel>
                    </>
                )}
            </Disclosure>
        </>
    )
}

export default AdminHeader
